import { IIndustryResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';
import { Modify } from 'utils/types';

export const defaultIndustriesSort: DataSourceSort[] = [{ field: 'Name', dir: 'asc' }];

export type IndustriesFilter = Readonly<{
    nameSearch?: string;
}>;

export type IndustriesDataSourceOptions = Modify<
    BaseDataSourceOptions<IIndustryResponse, IndustriesFilter>,
    { defaultIndustriesSort?: DataSourceSort[] }
>;
export type IndustriesPagedDataSource = PagedDataSource<
    IIndustryResponse,
    IndustriesFilter
>;

const getAllIndustries: DataSourceQuery<IIndustryResponse, IndustriesFilter> = ({
    filter: { nameSearch },
    sort,
    page,
    pageLimit,
}) => {
    const filter = nameSearch ? Filter.contains('Name', nameSearch) : undefined;
    const orderBy = buildOrderBy(sort, { descNullsLast: ['Name'] });

    return toDataSourceResult(
        sdClient.getIndustries({ filter, page, pageLimit, orderBy, nameSearch }),
    );
};

export function usePagedIndustriesDataSource({
    defaultSort = defaultIndustriesSort,
    ...options
}: IndustriesDataSourceOptions): IndustriesPagedDataSource {
    return usePagedDataSource({
        defaultSort,
        ...options,
        query: getAllIndustries,
    });
}

export type IndustriesInfiniteDataSource = InfiniteDataSource<
    IIndustryResponse,
    IndustriesFilter
>;

export function useInfiniteIndustriesDataSource({
    defaultSort = defaultIndustriesSort,
    ...options
}: IndustriesDataSourceOptions): IndustriesInfiniteDataSource {
    return useInfiniteDataSource({
        defaultSort,
        ...options,
        query: getAllIndustries,
    });
}
